import React from 'react';
import people from '../../../../assets/icons/people.svg';
import styles from './nps.module.css';
import Totals from './_Totals';
import { formatNumber, formatPercentage } from '../../../../components/Percent';
import { RadialBar } from '@ant-design/charts';
import { Colors } from '../../../core/Theme';
// import {
//     Chart,
//     Interval,
//     Tooltip,
//     Legend,
//     View,
//     Axis,
//     Coordinate
//   } from 'bizcharts';
  
const getStyleForScore = (score: number) => {
    if(score < 0) return { color: 'rgba(255, 16, 4, 1)' };
    else if(score >= 0 && score < 50)  return { color: 'rgba(255, 187, 17, 1)' };
    else return { color: 'rgba(23, 136, 19, 1)' };
}

const NPS = ({ data } : { data: any}) => {
    const chartData = [ 
        { id: 'Detractores', value: data.NPS.detractors.total, percentage: data.NPS.detractors.percentage},
        { id: 'Pasivos', value: data.NPS.passive.total, percentage: data.NPS.passive.percentage},
        { id: 'Promotores', value: data.NPS.promoters.total, percentage: data.NPS.promoters.percentage}
    ];

    return <div className={styles.container}>
        <div className={styles.npsScore}>
            <span>NPS: </span><span style={getStyleForScore(data.NPS.score)}>{data.NPS.score}</span>
        </div>
        <div className={styles.containerInner}>
            <div className={styles.containerChart}>
            <RadialBar data={chartData}
                autoFit
                xField="id"
                yField="percentage"
                radius={0.9}
                innerRadius={0.4}
                barBackground={{ style: { fill: 'rgba(255,255,255,0.45)' } }}
                barStyle={{ lineCap: 'round' }}
                colorField="id"
                minBarWidth={27}
                tooltip={false}
                xAxis={{
                    grid: null,
                    label: {
                        style: {
                            fill: Colors.black,
                            fontFamily: '"Montserrat", sans-serif',
                            fontWeight: 'bold',
                            fontSize: 13,
                            textAlign: 'right'
                        },
                        offset: 20,
                        formatter: (text, item, number) => { return formatPercentage(chartData[number].percentage, 1)}
                    }
                }}
                color={[Colors.error, Colors.warning, Colors.success]}
                 />

            </div>
            <div className={styles.containerNPS}>
                <div className={styles.titles}>
                    <div className={styles.titleDetr}>Detractores</div>
                    <div className={styles.titlePass}>Pasivos</div>
                    <div className={styles.titleProm}>Promotores</div>
                </div>
                <div className={styles.nps}>
                    <img src={people} alt="background" />
                </div>
                <div className={styles.scores}>
                    <div className={styles.scoreDetr} title={data.NPS.detractors.total}><span>{data.NPS.detractors.total >= 1000 ? formatNumber(data.NPS.detractors.total/1000, 1) + 'k' : data.NPS.detractors.total}</span></div>
                    <div className={styles.scorePass} title={data.NPS.passive.total}><span>{data.NPS.passive.total >= 1000 ? formatNumber(data.NPS.passive.total/1000, 1) + 'k' : data.NPS.passive.total}</span></div>
                    <div className={styles.scoreProm} title={data.NPS.promoters.total}><span>{data.NPS.promoters.total >= 1000 ? formatNumber(data.NPS.promoters.total/1000, 1) + 'k' : data.NPS.promoters.total}</span></div>
                </div>
            </div>
        </div>
        <Totals data={data} showAverage={false} />
    </div>
        };

export default NPS;